module.exports = __webpack_public_path__ + "static/img/invited_activity_demo.0829abd5.png";